import { render, staticRenderFns } from "./ListChaves.vue?vue&type=template&id=5de93870&"
import script from "./ListChaves.vue?vue&type=script&lang=js&"
export * from "./ListChaves.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports